/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Box } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Errors({ property, errors, classes, onlyFirst = false }) {
  const { t } = useTranslation();
  return errors && errors[property] ? (
    <Box variant="body1" className={classes.validation}>
      {Object.entries(errors[property].types).map(([key, value], idx) => (
        <div key={`${property}-${key}`}>
          {idx === 0 || onlyFirst === false ? (
            <Box color="error.main">
              <span id={`${property}ErrorMessage`} name="fieldErrorMessage">
                {t(value)}
              </span>
            </Box>
          ) : null}
        </div>
      ))}
    </Box>
  ) : (
    <div />
  );
}
